import Group from './group';
import Radio from './radio';
import './styles/index.scss';
const ExpandedRadio = Radio;
ExpandedRadio.Group = Group;
export { Radio, Group };
export default ExpandedRadio;
